export const getBacCategories = (subject: string) => {
    let categories: {
        id: number,
        name: string,
        description?: string,
        mode?: "radio" | "checkbox",
        subcategories: { id: string; name: string, description?: string, checked?: boolean }[]
    }[];

    if (subject === "bac-mate") {
        categories = [{
            id: 1,
            mode: "checkbox",
            name: "Module Bacalaureat Știinte / Tehnic(M2 / M3)",
            subcategories: [
                {
                    id: "module1",
                    checked: false,
                    name: "Algebră și Geometrie (IX,X) - Modul I",
                    description: "Acest modul conține itemi ce evaluează competențele de Matematică dobândite în clasa a IX-a și a X-a, specifice examenului de Bacalaureat, Subiectul I."
                },
                {
                    id: "module2",
                    checked: false,
                    name: "Algebră (XI, XII) - Modul II",
                    description: "Acest modul conține itemi ce evaluează competențele de Matematică dobândite în clasa a XI-a și a XII-a, specifice examenului de Bacalaureat, Subiectul II."
                },
                {
                    id: "module3",
                    checked: false,
                    name: "Analiză Matematică (XI, XII) - Modul III",
                    description: "Acest modul conține itemi ce evaluează competențele de Matematică dobândite în clasa a XI-a și a XII-a, specifice examenului de Bacalaureat, Subiectul III."
                },
            ]
        }]
    } else if (subject === "bac-mate-info") {
        categories = [
            {
                id: 2,
                mode: "checkbox",
                name: "Module Bacalaureat Matematică/Informatică (M1)",
                subcategories: [
                    {
                        id: "module1",
                        checked: false,
                        name: "Algebră și Geometrie (IX,X) - Modul I",
                        description: "Acest modul conține itemi ce evaluează competențele de Matematică dobândite în clasa a IX-a și a X-a, specifice examenului de Bacalaureat, Subiectul I.",
                    },
                    {
                        id: "module2",
                        checked: false,
                        name: "Algebră (XI, XII) - Modul II",
                        description: "Acest modul conține itemi ce evaluează competențele de Matematică dobândite în clasa a XI-a și a XII-a, specifice examenului de Bacalaureat, Subiectul II.",
                    },
                    {
                        id: "module3",
                        checked: false,
                        name: "Analiză Matematică (XI, XII) - Modul III",
                        description: "Acest modul conține itemi ce evaluează competențele de Matematică dobândite în clasa a XI-a și a XII-a, specifice examenului de Bacalaureat, Subiectul III.",
                    }
                ]
            }
        ]
    } else if (subject === "bac-romana") {
        categories = [
            {
                id: 3,
                mode: "checkbox",
                name: "Module Bacalaureat Română",
                subcategories: [
                    {
                        id: "module1",
                        checked: false,
                        name: "Limbă și comunicare - Modul I",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și literatura română dobândite în liceu, specifice programei examenului de Bacalaureat, referitoare la Limbă și comunicare.",
                    },
                    {
                        id: "module2",
                        checked: false,
                        name: "Text literar studiat - Modul II",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și literatura română dobândite în liceu, specifice programei examenului de Bacalaureat, referitoare la Textul literar studiat.",
                    },
                    {
                        id: "module3",
                        checked: false,
                        name: "Text literar la prima vedere - Modul III",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și literatura română dobândite în liceu, specifice programei examenului de Bacalaureat, referitoare la Textul literar la prima vedere.",
                    },
                    {
                        id: "module4",
                        checked: false,
                        name: "Text nonliterar - Modul IV",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și literatura română dobândite în liceu, specifice programei examenului de Bacalaureat, referitoare la Textul nonliterar.",
                    }
                ]
            }
        ]
    } else if (subject === "bac-istorie") {
        categories = [
            {
                id: 4,
                mode: "checkbox",
                name: "Module Bacalaureat Istorie",
                subcategories: [
                    {
                        id: "module1",
                        checked: false,
                        name: "Modul I",
                        description: "Acest modul conține itemi ce evaluează competențele de Istorie din categoriile \"Romanitatea românilor în viziunea istoricilor\" și \"Autonomii locale și instituții centrale în spațiul românesc (secolele IX-XVIII)\".",
                    },
                    {
                        id: "module2",
                        checked: false,
                        name: "Modul II",
                        description: "Acest modul conține itemi ce evaluează competențele de Istorie din categoria \"Spațiul românesc între diplomație și conflict în Evul Mediu și la începuturile modernității\".",
                    },
                    {
                        id: "module3",
                        checked: false,
                        name: "Modul III",
                        description: "Acest modul conține itemi ce evaluează competențele de Istorie din categoria \"Statul român modern: de la proiect politic la realizarea României Mari. (secolele XVIII-XX)\".",
                    },
                    {
                        id: "module4",
                        checked: false,
                        name: "Modul IV",
                        description: "Acest modul conține itemi ce evaluează competențele de Istorie din categoriile \"România și concertul european: de la „criza orientală” la marile alianțe ale secolului XX\", \"Constituțiile din România\" și \"Secolul XX – între democrație și totalitarism. Ideologii și practici politice în România și în Europa\".",
                    },
                    {
                        id: "module5",
                        checked: false,
                        name: "Modul V",
                        description: "Acest modul conține itemi ce evaluează competențele de Istorie din categoriile \"România postbelică. Stalinism, național-comunism și disidență anticomunistă. Construcția democrației postdecembriste\" și \"România în perioada Războiului Rece\".",
                    }
                ]
            }
        ]
    } else if (subject === "evaluare-nationala-mate") {
        categories = [
            {
                id: 5,
                mode: "checkbox",
                name: "Module Evaluare Națională Matematică",
                subcategories: [
                    {
                        id: "module1",
                        checked: false,
                        name: "Algebră - Modul I",
                        description: "Acest modul conține itemi ce evaluează competențele de algebră dobândite în gimnaziu, specifice programei pentru Evaluarea Națională."
                    },
                    {
                        id: "module2",
                        checked: false,
                        name: "Geometrie - Modul II",
                        description: "Acest modul conține itemi ce evaluează competențele de geometrie dobândite în gimnaziu, specifice programei pentru Evaluarea Națională."
                    },
                    {
                        id: "module3",
                        checked: false,
                        name: "Algebră și Geometrie - Modul III",
                        description: "Acest modul conține itemi ce evaluează competențele de algebră și geometrie dobândite în gimnaziu, specifice programei pentru Evaluarea Națională."
                    },
                ]
            },
            // {
            //     id: 6,
            //     name: "Simulare Evaluare Națională Matematică",
            //     description: "Fiecare variantă conține 24 probleme.",
            //     mode: "radio",
            //     subcategories: [
            //         {
            //             id: "1",
            //             checked: false,
            //             name: "Varianta 1",
            //         },
            //         {
            //             id: "2",
            //             checked: false,
            //             name: "Varianta 2",
            //         },
            //         {
            //             id: "3",
            //             checked: false,
            //             name: "Varianta 3",
            //         },
            //         {
            //             id: "4",
            //             checked: false,
            //             name: "Varianta 4",
            //         },
            //         {
            //             id: "5",
            //             checked: false,
            //             name: "Varianta 5",
            //         },
            //         {
            //             id: "6",
            //             checked: false,
            //             name: "Varianta 6",
            //         },
            //         {
            //             id: "7",
            //             checked: false,
            //             name: "Varianta 7",
            //         },
            //         {
            //             id: "8",
            //             checked: false,
            //             name: "Varianta 8",
            //         },
            //         {
            //             id: "9",
            //             checked: false,
            //             name: "Varianta 9",
            //         },
            //         {
            //             id: "10",
            //             checked: false,
            //             name: "Varianta 10",
            //         },
            //         {
            //             id: "11",
            //             checked: false,
            //             name: "Varianta 11",
            //         },
            //         {
            //             id: "12",
            //             checked: false,
            //             name: "Varianta 12",
            //         },
            //         {
            //             id: "13",
            //             checked: false,
            //             name: "Varianta 13",
            //         },
            //         {
            //             id: "14",
            //             checked: false,
            //             name: "Varianta 14",
            //         },
            //         {
            //             id: "15",
            //             checked: false,
            //             name: "Varianta 15",
            //         },
            //     ]
            // }
        ]
    } else if (subject === "evaluare-nationala-romana") {
        categories = [
            {
                id: 7,
                mode: "checkbox",
                name: "Module Evaluare Națională Română",
                subcategories: [
                    {
                        id: "module1",
                        checked: false,
                        name: "Fonetică, vocabular, ortografie și punctuație - Modul I",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și Literatura română dobândite în gimnaziu, specifice programei pentru Evaluarea Națională, referitoare la Fonetică, vocabular, ortografie și punctuație.",
                    },
                    {
                        id: "module2",
                        checked: false,
                        name: "Morfologie și sintaxă - Modul II",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și Literatura română dobândite în gimnaziu, specifice programei pentru Evaluarea Națională, referitoare la Morfologie și sintaxă.",
                    },
                    {
                        id: "module3",
                        checked: false,
                        name: "Genuri și specii literare - Modul III",
                        description: "Genuri și specii literare\" cu descrierea \"Acest modul conține itemi ce evaluează competențele de Limba și Literatura Română dobândite în gimnaziu, specifice programei pentru Evaluarea Națională, referitoare la Genuri și specii literare.",
                    },
                    {
                        id: "module4",
                        checked: false,
                        name: "Textul literar și nonliterar - Modul IV",
                        description: "Textul literar și nonliterar\" cu descrierea \"Acest modul conține itemi ce evaluează competențele de Limba și Literatura Română dobândite în gimnaziu, specifice programei pentru Evaluarea Națională, referitoare la Textul literar și nonliterar.",
                    },
                    {
                        id: "module5",
                        checked: false,
                        name: "Versificație, figuri de stil și imagini artistice - Modul V",
                        description: "Acest modul conține itemi ce evaluează competențele de Limba și literatura Română dobândite în gimnaziu, specifice programei pentru Evaluarea Națională, referitoare la Versificație, figuri de stil și imagini artistice.",
                    },
                ]
            }
        ]
    } else {
        categories = [];
    }

    return categories;
}